/*
 * @Author: your name
 * @Date: 2021-10-11 11:44:01
 * @LastEditTime: 2021-11-15 14:16:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mrc\src\service\api\staffType.js
 */
//员工等级
import http from '../httpConfig'

const table = "mrbase_sys_staff_grade"

// 员工等级列表
export const staff_grade_list = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-grade/list-staff-grade/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 新增员工等级
export const staff_grade_add = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-grade/add-staff-grade/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 修改员工等级
export const staff_grade_edit = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-grade/update-staff-grade/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 查询员工等级详情
export const staff_grade_detail = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-grade/find-staff-grade/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 删除员工等级
export const staff_grade_delete = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-grade/delete-staff-grade/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

